// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"6475c846","606":"929e84a1","703":"cc13974f"}[chunkId] + ".chunk.js";
};